import Flux from 'lib/flux';
import BookingRequestService from 'services/booking_request';
import BookingRequestConstants from 'constants/booking_request';
import debounce from 'throttle-debounce/debounce';

const gTagCompleteCheckout = (params) => {
  const {
    bookingId,
    currency,
    tourId,
    unitPrice,
    tourName,
    totalPrice,
    guests,
    total_without_service_fee,
    unit_price_for_initial_pricing,
    units_and_addons_detail,
    isGa4Enabled,
    discountPricing,
    totalTax,
  } = params;
  try {
    // eslint-disable-next-line no-undef
    googleTagManagerCompleteCheckout({
      booking_id: bookingId,
      total_price: totalPrice,
      currency: currency.toUpperCase(),
      tour_id: tourId,
      tour_name: tourName,
      unit_price: unitPrice,
      quantity: guests,
      discount_pricing: discountPricing,
      total_tax: totalTax,
      is_ga4_enabled: isGa4Enabled,
      total_without_service_fee,
      unit_price_for_initial_pricing,
      units_and_addons_detail,
    });
  } catch (error) {
    console.log('google tag error', error);
  }
};

const salesforceKruxCompleteCheckout = (params) => {
  const {
    date,
    guestEmail,
    tourName,
    guests,
    billingCity,
    billingRegion,
    npsAndBehaviorResponses,
    bookingDate,
    tourCity,
    guestGender,
  } = params;
  const { nps, purchase_behavior } = npsAndBehaviorResponses;

  try {
    // eslint-disable-next-line no-undef
    salesforceCompleteCheckout({
      date,
      guest_email: guestEmail,
      tour_name: tourName,
      guests,
      billing_city: billingCity,
      billing_region: billingRegion,
      nps,
      purchase_behavior,
      booking_date: bookingDate,
      tour_city: tourCity,
      guest_gender: guestGender,
    });
  } catch (error) {
    console.log('salesforce krux pixel error', error);
  }
};

const BookingRequestActionCreator = Flux.createActionCreator({
  change: debounce(400, function (fields) {
    this.dispatchAction(BookingRequestConstants.CHANGE, fields);
  }),

  save(params) {
    this.dispatchAction(BookingRequestConstants.SAVE);

    return BookingRequestService.save(params).then(
      (resp) => {
        this.dispatchAction(BookingRequestConstants.SAVE_COMPLETED, resp);
      },
      (errors) => {
        this.dispatchAction(BookingRequestConstants.SAVE_FAILED, errors);
      }
    );
  },

  commit(params) {
    this.dispatchAction(BookingRequestConstants.COMMIT);

    BookingRequestService.commit(params).then(
      (resp) => {
        if (!resp.actionRequired) {
          gTagCompleteCheckout(resp);
          salesforceKruxCompleteCheckout(resp);
        }
        this.dispatchAction(BookingRequestConstants.COMMIT_COMPLETED, resp);
      },
      (errors) => {
        this.dispatchAction(BookingRequestConstants.COMMIT_FAILED, errors);
      }
    );
  },

  applyDiscount(params) {
    this.dispatchAction(BookingRequestConstants.APPLY_DISCOUNT);

    BookingRequestService.applyDiscount(params).then(
      (resp) => {
        this.dispatchAction(
          BookingRequestConstants.APPLY_DISCOUNT_COMPLETED,
          resp
        );
      },
      (xhr, _textStatus, _error) => {
        const resp = xhr.responseJSON;
        this.dispatchAction(
          BookingRequestConstants.APPLY_DISCOUNT_FAILED,
          resp
        );
      }
    );
  },

  removeDiscount(params) {
    this.dispatchAction(BookingRequestConstants.REMOVE_DISCOUNT);

    BookingRequestService.removeDiscount(params).then(
      (resp) => {
        this.dispatchAction(
          BookingRequestConstants.REMOVE_DISCOUNT_COMPLETED,
          resp
        );
      },
      (xhr, _textStatus, _error) => {
        const resp = xhr.responseJSON;
        this.dispatchAction(
          BookingRequestConstants.REMOVE_DISCOUNT_FAILED,
          resp
        );
      }
    );
  },

  fetchSummary(id) {
    this.dispatchAction(BookingRequestConstants.FETCH_SUMMARY);
    BookingRequestService.fetchSummary({ id }).then(
      (resp) => {
        this.dispatchAction(
          BookingRequestConstants.FETCH_SUMMARY_COMPLETED,
          resp
        );
      },
      (_xhr, _textStatus, _error) => {
        this.dispatchAction(BookingRequestConstants.FETCH_SUMMARY_FAILED);
      }
    );
  },

  setStatusCommitted() {
    this.dispatchAction(BookingRequestConstants.STATUS_COMMITTED);
  },

  completeAuth(params) {
    BookingRequestService.updatePayment(params).then(() => {
      this.dispatchAction(BookingRequestConstants.AUTH_COMPLETED, {});
    });
  },

  setStripePaymentError(error) {
    this.dispatchAction(BookingRequestConstants.STRIPE_PAYMENT_ERROR, error);
  },

  addCardElement(card) {
    this.dispatchAction(BookingRequestConstants.ADD_STRIPE_CARD_ELEMENT, card);
  },

  resetStripeAuth() {
    this.dispatchAction(BookingRequestConstants.RESET_STRIPE_AUTH);
  },

  setStripeToken(token) {
    this.dispatchAction(BookingRequestConstants.SET_STRIPE_TOKEN, token);
  },
});

export default BookingRequestActionCreator;
